import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ShoppingCartPageComponent } from '../pages/cms/shopping-cart/shopping-cart-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<ShoppingCartPageComponent>
{
  canDeactivate(
    component: ShoppingCartPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.shoppingCartForm),
      nextState.url,
      () => component.resetFormChanges,
      () => component.save()
    );
  }
}
